/**
 * Extract a user-facing error message from an API error (e.g. axios error).
 * Uses response.data.message, or response.data.errors[] (validation), or fallback.
 * @param {Error} error - Caught error (e.response?.data may contain message or errors)
 * @param {string} fallback - Message when nothing can be extracted
 * @returns {string}
 */
export function getErrorMessage(error, fallback = 'An error occurred. Please try again.') {
  if (!error || typeof error !== 'object') return fallback;
  const data = error.response?.data;
  if (data?.message && typeof data.message === 'string') return data.message;
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    const parts = data.errors.map((e) => e.msg || e.message).filter(Boolean);
    if (parts.length) return parts.join('. ');
  }
  if (typeof error.message === 'string' && error.message) return error.message;
  return fallback;
}
